import { create } from "zustand";

const initialSession = {
  messages: [],
  draft: "",
  pendingProposal: null,
  nextMessageId: 0,
};

const useParametricAiSessionStore = create((set) => ({
  ...initialSession,

  initializeConversation: (cellName) =>
    set((state) => {
      if (state.messages.length > 0 || !cellName) return state;

      const nextMessageId = state.nextMessageId + 1;
      return {
        nextMessageId,
        messages: [{
          id: `${cellName}-${nextMessageId}`,
          role: "assistant",
          text: `What would you like to change in ${cellName}?`,
        }],
      };
    }),

  appendMessage: (cellName, role, text, extra = {}) =>
    set((state) => {
      const nextMessageId = state.nextMessageId + 1;
      return {
        nextMessageId,
        messages: [
          ...state.messages,
          {
            id: `${cellName || "pcell"}-${nextMessageId}`,
            role,
            text,
            ...extra,
          },
        ],
      };
    }),

  setDraft: (draft) => set({ draft }),
  setPendingProposal: (pendingProposal) => set({ pendingProposal }),

  resetSession: () => set({ ...initialSession }),
}));

export default useParametricAiSessionStore;
